<template>
  <div class="content">
    <!-- 业务卡片分类容器 -->
    <div class="business-container">
      <!-- 北交所分类 -->
      <div class="business-category">
        <h3 class="category-title">
          <span class="tag beijing-exchange">北交所</span>
        </h3>
        
        <!-- Top50 大卡片区域 - 一排三个 -->
        <div class="featured-cards">
          <div class="featured-card" @click="goToTop50">
            <div class="featured-header">
              <span class="featured-badge">子沐Top50</span>
            </div>
            <div class="featured-main">
              <div class="featured-value" :class="{ 'value-up': totalReturn >= 0, 'value-down': totalReturn < 0 }">
                {{ totalReturn.toFixed(1) }}%
              </div>
              <div class="featured-label">总收益</div>
            </div>
            <div class="featured-periods">
              <div class="period-item" v-for="(item, key) in periodReturns" :key="key">
                <span class="period-label">{{ item.label }}</span>
                <span class="period-value" :class="{ 'value-up': item.value >= 0, 'value-down': item.value < 0 }">
                  {{ item.value.toFixed(1) }}%
                </span>
              </div>
            </div>
            <div class="featured-chart">
              <canvas id="top50MiniChart"></canvas>
            </div>
          </div>
          
          <!-- 调研报告卡片（北交所） -->
          <div class="featured-card featured-card-report">
            <!-- 顶部操作栏 -->
            <div class="report-top-bar">
              <button class="entrust-btn" @click.stop="handleEntrustResearch('BJ')">委托调查</button>
              <span class="more-link" @click.stop="goToInvestigationReport">More>></span>
            </div>
            
            <!-- 有数据时显示报告内容 -->
            <div v-if="latestReport" class="report-card-body" @click="goToInvestigationReport">
              <div class="card-cover">
                <div v-if="!latestReport.front_url" class="default-cover">
                  <el-icon class="file-icon"><Document /></el-icon>
                </div>
                <img 
                  v-else 
                  :src="latestReport.front_url" 
                  alt="报告封面" 
                  class="cover-img"
                  @error="handleImgError($event)"
                >
              </div>
              <div class="card-content" style="background: white !important;">
                <div class="report-info" style="color: #333 !important;">
                  <div class="company-info">
                    <span class="company-name-large" style="color: #333 !important; font-size: 16px !important; font-weight: 700 !important;">{{ latestReport.comp_name || '暂无数据' }}</span>
                    <span class="company-code" style="color: #666 !important; font-size: 14px !important;" v-if="latestReport.comp_code">({{ latestReport.comp_code }})</span>
                  </div>
                  <div class="title-date-row">
                    <h3 class="report-title-main" style="color: #333 !important; font-size: 15px !important; font-weight: 600 !important;">{{ latestReport.resch_title || '暂无标题' }}</h3>
                    <div class="report-date" style="color: #999 !important; font-size: 13px !important;">{{ formatDate(latestReport.resch_time) || '暂无日期' }}</div>
                  </div>
                  <div class="report-tag-small" style="color: #1890ff !important; background: #e6f7ff !important; font-size: 11px !important;" v-if="latestReport.resch_type_nm">{{ latestReport.resch_type_nm }}</div>
                </div>
              </div>
            </div>
            
            <!-- 无数据时显示暂无数据 -->
            <div v-else class="report-placeholder">
              <span class="placeholder-text">暂无数据</span>
            </div>
          </div>
          
          <!-- 龙虎榜交易柱状图卡片 -->
          <div class="featured-card featured-card-chart" @click="goToDragonTigerList">
            <div class="featured-header">
              <span class="featured-badge">龙虎榜交易</span>
            </div>
            <div class="featured-chart-full">
              <canvas id="dragonTigerChart"></canvas>
            </div>
          </div>
        </div>
        
        <!-- 其他小卡片：使用与 IPO 相同的三区域布局 -->
        <div class="card-list bj-card-list">
          <div 
            v-for="(item, index) in beijingExchangeList" 
            :key="index" 
            class="business-card ipo-card"
            @click="handleCardClick(item)"
          >
            <!-- 左区：图标+标题+描述 -->
            <div class="ipo-left">
              <div class="card-icon" :style="{ backgroundColor: item.iconBg }">
                <span>{{ item.icon }}</span>
              </div>
              <div class="ipo-text">
                <div class="ipo-title">{{ item.title }}</div>
                <div class="ipo-desc">{{ item.desc }}</div>
              </div>
            </div>
            
            <!-- 中区：大数字 -->
            <div class="ipo-center" v-if="item.count > 0">
              <span class="ipo-number">{{ item.count.toLocaleString() }}</span>
            </div>
            <div class="ipo-center" v-else>
              <span class="ipo-loading">--</span>
            </div>
            
            <!-- 右区：单位 -->
            <div class="ipo-right">
              <span class="ipo-unit">个</span>
            </div>
          </div>
        </div>
      </div>

      <!-- IPO分类 -->
      <div class="business-category">
        <h3 class="category-title">
          <span class="tag ipo">IPO</span>
        </h3>
        
        <!-- IPO 卡片列表：每个卡片内部分三个区域 -->
        <div class="card-list ipo-card-list">
          <div 
            v-for="(item, index) in ipoList" 
            :key="index" 
            class="business-card ipo-card"
            @click="handleCardClick(item)"
          >
            <!-- 左区：图标+标题+描述 -->
            <div class="ipo-left">
              <div class="card-icon" :style="{ backgroundColor: item.iconBg }">
                <span>{{ item.icon }}</span>
              </div>
              <div class="ipo-text">
                <div class="ipo-title">{{ item.title }}</div>
                <div class="ipo-desc">{{ item.desc }}</div>
              </div>
            </div>
            
            <!-- 中区：大数字 -->
            <div class="ipo-center" v-if="item.count > 0">
              <span class="ipo-number">{{ item.count.toLocaleString() }}</span>
            </div>
            <div class="ipo-center" v-else>
              <span class="ipo-loading">--</span>
            </div>
            
            <!-- 右区：单位 -->
            <div class="ipo-right">
              <span class="ipo-unit">家</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 新三板分类 -->
      <div class="business-category">
        <h3 class="category-title">
          <span class="tag w-third-boardne">新三板</span>
        </h3>
        
        <!-- 大卡片区域：与北交所相同的布局 -->
        <div class="featured-cards">
          <!-- 委托定增列表卡片 -->
          <div class="featured-card featured-card-list">
            <div class="featured-header">
              <span class="featured-badge">委托定增</span>
              <span class="more-link" @click.stop="goToPrivatePlacement">More>></span>
            </div>
            <div class="list-content" v-if="fixedIncreaseList.length > 0">
              <div class="list-item" v-for="(item, index) in fixedIncreaseList.slice(0, 5)" :key="index">
                <span class="item-code">{{ item.comp_code }}</span>
                <span class="item-name">{{ item.comp_name }}</span>
                <span class="item-tag" v-if="item.sub_type">{{ item.sub_type }}</span>
              </div>
            </div>
            <div class="list-placeholder" v-else>
              <span class="placeholder-text">暂无数据</span>
            </div>
          </div>
          
          <!-- 委托壳交易列表卡片 -->
          <div class="featured-card featured-card-list">
            <div class="featured-header">
              <span class="featured-badge">委托壳交易</span>
              <span class="more-link" @click.stop="goToShellTransactions">More>></span>
            </div>
            <div class="list-content" v-if="shellTransactionList.length > 0">
              <div class="list-item" v-for="(item, index) in shellTransactionList.slice(0, 5)" :key="index">
                <!-- 如果是买壳，显示用户名；如果是卖壳，显示公司信息 -->
                <template v-if="item.sub_type === '买壳'">
                  <span class="item-name">买壳</span>
                  <span class="item-name">{{ maskUserName(item.user_name) }}</span>
                </template>
                <template v-else>
                  <span class="item-code">{{ item.comp_code }}</span>
                  <span class="item-name">{{ item.comp_name }}</span>
                </template>
                <span class="item-tag" v-if="item.sub_type">{{ item.sub_type }}</span>
              </div>
            </div>
            <div class="list-placeholder" v-else>
              <span class="placeholder-text">暂无数据</span>
            </div>
          </div>
          
          <!-- 调研报告卡片（新三板） -->
          <div class="featured-card featured-card-report">
            <!-- 顶部操作栏 -->
            <div class="report-top-bar">
              <button class="entrust-btn" @click.stop="handleEntrustResearch('NQ')">委托调查</button>
              <span class="more-link" @click.stop="goToNQInvestigationReport">More>></span>
            </div>
            
            <!-- 有数据时显示报告内容 -->
            <div v-if="latestNQReport" class="report-card-body" @click="goToNQInvestigationReport">
              <div class="card-cover">
                <div v-if="!latestNQReport.front_url" class="default-cover">
                  <el-icon class="file-icon"><Document /></el-icon>
                </div>
                <img 
                  v-else 
                  :src="latestNQReport.front_url" 
                  alt="报告封面" 
                  class="cover-img"
                  @error="handleImgError($event)"
                >
              </div>
              <div class="card-content" style="background: white !important;">
                <div class="report-info" style="color: #333 !important;">
                  <div class="company-info">
                    <span class="company-name-large" style="color: #333 !important; font-size: 16px !important; font-weight: 700 !important;">{{ latestNQReport.comp_name || '暂无数据' }}</span>
                    <span class="company-code" style="color: #666 !important; font-size: 14px !important;" v-if="latestNQReport.comp_code">({{ latestNQReport.comp_code }})</span>
                  </div>
                  <div class="title-date-row">
                    <h3 class="report-title-main" style="color: #333 !important; font-size: 15px !important; font-weight: 600 !important;">{{ latestNQReport.resch_title || '暂无标题' }}</h3>
                    <div class="report-date" style="color: #999 !important; font-size: 13px !important;">{{ formatDate(latestNQReport.resch_time) || '暂无日期' }}</div>
                  </div>
                  <div class="report-tag-small" style="color: #1890ff !important; background: #e6f7ff !important; font-size: 11px !important;" v-if="latestNQReport.resch_type_nm">{{ latestNQReport.resch_type_nm }}</div>
                </div>
              </div>
            </div>
            
            <!-- 无数据时显示暂无数据 -->
            <div v-else class="report-placeholder">
              <span class="placeholder-text">暂无数据</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 一级市场分类 -->
      <div class="business-category">
        <h3 class="category-title">
          <span class="tag primary-market">一级市场</span>
        </h3>
        
        <!-- 大卡片区域：立项公司列表 -->
        <div class="featured-cards">
          <!-- 立项公司列表卡片 -->
          <div class="featured-card featured-card-list">
            <div class="featured-header">
              <span class="featured-badge">立项公司</span>
              <span class="more-link" @click.stop="goToProjectFoundList">More>></span>
            </div>
            <div class="list-content" v-if="projectFoundList.length > 0">
              <div class="list-item" v-for="(item, index) in projectFoundList.slice(0, 5)" :key="index">
                <span class="item-name">{{ item.comp_name }}</span>
                <span class="item-name">{{ formatDateOnly(item.project_date) }}</span>
                <span class="item-name">{{ maskUserName(item.user_name) }}</span>
              </div>
            </div>
            <div class="list-placeholder" v-else>
              <span class="placeholder-text">暂无数据</span>
            </div>
          </div>
          
          <!-- 投前项目列表卡片 -->
          <div class="featured-card featured-card-list">
            <div class="featured-header">
              <span class="featured-badge">投前项目</span>
              <span class="more-link" @click.stop="goToPreInvestment">More>></span>
            </div>
            <div class="list-content" v-if="preInvestmentList.length > 0">
              <div class="list-item" v-for="(item, index) in preInvestmentList.slice(0, 5)" :key="index">
                <span class="item-name">{{ item.comp_name }}</span>
                <span class="item-name">{{ formatDateOnly(item.pre_date) }}</span>
                <span class="item-name">{{ maskUserName(item.user_name) }}</span>
              </div>
            </div>
            <div class="list-placeholder" v-else>
              <span class="placeholder-text">暂无数据</span>
            </div>
          </div>
          
          <!-- 投中项目列表卡片 -->
          <div class="featured-card featured-card-list">
            <div class="featured-header">
              <span class="featured-badge">投中项目</span>
              <span class="more-link" @click.stop="goToDuringInvestment">More>></span>
            </div>
            <div class="list-content" v-if="duringInvestmentList.length > 0">
              <div class="list-item" v-for="(item, index) in duringInvestmentList.slice(0, 5)" :key="index">
                <span class="item-name">{{ item.comp_name }}</span>
                <span class="item-name">{{ formatDateOnly(item.dura_date) }}</span>
                <span class="item-name">{{ maskUserName(item.user_name) }}</span>
              </div>
            </div>
            <div class="list-placeholder" v-else>
              <span class="placeholder-text">暂无数据</span>
            </div>
          </div>
        </div>
      </div>

    </div>
    
    <!-- 委托调研弹窗 -->
    <ConfirmResearchModal
      v-if="showModal"
      :visible="showModal"
      @update:visible="showModal = $event"
      :business-type="currentBusinessType"
      :user-info="userInfo"
      :comp-exch="currentCompExch"
      @on-confirm="handleModalConfirm"
      @on-close="handleModalClose"
    />
  </div>
</template>

<script>
import { stockPoolApi, newThirdBoardApi, beijingStockApi, ipoApi, primaryMarketApi } from '@/api/index';
import Chart from 'chart.js/auto';
import { markRaw } from 'vue';
import { Document } from '@element-plus/icons-vue';
import ConfirmResearchModal from '@/components/confirmResearchModal.vue';
import { useUserStore } from "@/store/userStore.js";

export default {
  name: 'BusinessCardList',
  components: {
    Document,
    ConfirmResearchModal
  },
  data() {
    return {
      // Top50 数据
      portfolioData: null,  
      totalReturn: 0,
      periodReturns: {
        day: { label: '日', value: 0 },
        month: { label: '月', value: 0 },
        threeMonth: { label: '三月', value: 0 },
        sixMonth: { label: '六月', value: 0 },
        year: { label: '一年', value: 0 }
      },
      bjTop50IndexData: [],  // getTop50Index 返回的指数数据
      shTop50IndexData: [],
      customIndexData: [],
      chartInstance: null,
      ipoServiceData: null,
      
      // 调研报告数据
      latestReport: null,  // 北交所最新调研报告
      latestNQReport: null,  // 新三板最新调研报告
      
      // 龙虎榜数据
      dragonTigerData: [],  // 龙虎榜交易数据
      dragonTigerChartInstance: null,  // 柱状图实例
      
      // 业务列表数据
      fixedIncreaseList: [],  // 委托定增列表
      shellTransactionList: [],  // 委托壳交易列表
      projectFoundList: [],  // 立项公司列表
      preInvestmentList: [],  // 投前项目列表
      duringInvestmentList: [],  // 投中项目列表
      
      // 弹窗相关
      showModal: false,
      currentBusinessType: "",
      currentCompExch: "",
      userInfo: {},
      
      // 北交所卡片数据
      beijingExchangeList: [
        { 
          title: '核心池', 
          desc: '精选优质标的', 
          icon: '★', 
          iconBg: '#ff7f50',
          route: { name: 'corePool', params: { comp_exch: 'BJ' } },
          count: 0,
          dataKey: '核心池'
        },
        { 
          title: '行业分类', 
          desc: '分类标签', 
          icon: '●', 
          iconBg: '#9370db',
          route: { name: 'sectorDataTable' },
          count: 0,
          dataKey: '标签'
        },
        { 
          title: '并购重组', 
          desc: '进行中', 
          icon: '◎', 
          iconBg: '#9370db',
          route: { name: 'mergersAndAcquisitions'},
          count: 0,
          dataKey: '并购重组'
        }
      ],
      // IPO卡片数据
      ipoList: [
        { 
          title: '潜力公司', 
          desc: '高成长标的', 
          icon: '☆', 
          iconBg: '#ff4500',
          route: { name: 'highPotentialCompany' },
          count: 0,
          dataKey: '潜力公司'
        },
        { 
          title: '筹备期', 
          desc: '汇总', 
          icon: '●', 
          iconBg: '#ff8c00',
          route: { name: 'ipoStateList', params: { state_stage: '筹备期' } },
          count: 0,
          dataKey: '筹备期'
        },
        { 
          title: '辅导期', 
          desc: '汇总', 
          icon: '◆', 
          iconBg: '#cd5c5c',
          route: { name: 'ipoStateList', params: { state_stage: '辅导期' } },
          count: 0,
          dataKey: '辅导期'
        },
        { 
          title: '审核期', 
          desc: '汇总', 
          icon: '▲', 
          iconBg: '#ffa500',
          route: { name: 'ipoStateList', params: { state_stage: '审核期' } },
          count: 0,
          dataKey: '审核期'
        },
        { 
          title: '审议期', 
          desc: '汇总', 
          icon: '◆', 
          iconBg: '#cd5c5c',
          route: { name: 'ipoStateList', params: { state_stage: '审议期' } },
          count: 0,
          dataKey: '审议期'
        },
        { 
          title: '注册期', 
          desc: '汇总', 
          icon: '●', 
          iconBg: '#ff6347',
          route: { name: 'ipoStateList', params: { state_stage: '注册期' } },
          count: 0,
          dataKey: '注册期'
        }
      ]
    };
  },
  
  mounted() {
    // 初始化用户信息
    const userStore = useUserStore();
    this.userInfo = {
      projectContact: userStore.getUserName,
      contactPhone: userStore.getTel,
    };
    
    // 获取各类数据
    this.fetchTop50Data();
    this.fetchLatestReport();  // 获取北交所报告
    this.fetchLatestNQReport();  // 获取新三板报告
    this.fetchDragonTigerData();
    this.fetchIpoServiceData();
    this.fetchBeijingStockHomeData();
    this.fetchFixedIncreaseData();  // 获取委托定增数据
    this.fetchShellTransactionData();  // 获取委托壳交易数据
    this.fetchProjectFoundData();  // 获取立项公司数据
    this.fetchPreInvestmentData();  // 获取投前项目数据
    this.fetchDuringInvestmentData();  // 获取投中项目数据
  },
  
  beforeUnmount() {
    // 销毁图表实例
    if (this.chartInstance) {
      try {
        this.chartInstance.destroy();
      } catch (e) {
        console.error('[Top50卡片] 销毁图表失败:', e);
      }
      this.chartInstance = null;
    }
    
    // 销毁龙虎榜图表实例
    if (this.dragonTigerChartInstance) {
      try {
        this.dragonTigerChartInstance.destroy();
      } catch (e) {
        console.error('[龙虎榜卡片] 销毁图表失败:', e);
      }
      this.dragonTigerChartInstance = null;
    }
  },
  
  methods: {
    // 获取 Top50 数据（两个接口）
    async fetchTop50Data() {
      try {
        const userStore = useUserStore();
        // 1. 获取总收益和各周期收益（get_zimu_top50）
        const portRes = await stockPoolApi.getBJtop50({ 
          group_type: 50,
          comp_exch: 'BJ',
          user_id: userStore.userId
        });
        
        if (portRes && typeof portRes === 'object') {
          this.portfolioData = portRes;
          // 提取收益数据
          this.totalReturn = parseFloat(portRes.total_profit_rate) || 0;
          this.periodReturns.day.value = parseFloat(portRes.group_1d_profit_rate) || 0;
          this.periodReturns.month.value = parseFloat(portRes.group_30d_profit_rate) || 0;
          this.periodReturns.threeMonth.value = parseFloat(portRes.group_90d_profit_rate) || 0;
          this.periodReturns.sixMonth.value = parseFloat(portRes.group_180d_profit_rate) || 0;
          this.periodReturns.year.value = parseFloat(portRes.group_365d_profit_rate) || 0;
        }
        
        // 2. 获取曲线图数据（get_top50index）
        const indexRes = await stockPoolApi.getTop50Index({ 
          page_size: 3000,
          index_type: 'ZM'  // 必须传入 ZM 才能获取所有三种类型的指数数据
        });
        
        if (indexRes && typeof indexRes === 'object') {
          const list = indexRes.list || indexRes || [];
          // 分别过滤三类数据
          this.bjTop50IndexData = list.filter(i => i && i.index_type === 'BJ');
          this.shTop50IndexData = list.filter(i => i && i.index_type === 'SH');
          this.customIndexData = list.filter(i => i && i.index_type === 'ZM');
        }
        
        // 3. 初始化图表
        this.$nextTick(() => {
          this.initMiniChart();
        });
        
      } catch (err) {
        console.error('获取Top50数据失败：', err);
      }
    },
    
    // 获取最新调研报告（北交所）
    async fetchLatestReport() {
      try {
        const res = await newThirdBoardApi.getReschReport({
          page_idx: 1,
          page_size: 1,  // 只获取第一条
          comp_exch: 'BJ'
        });
        
        //('[北交所调研报告] 接口返回:', res);
        
        // 兼容处理：单条数据时返回对象，多条数据时返回 list 数组
        if (Array.isArray(res)) {
          this.latestReport = res[0];
        } else if (res && res.list && Array.isArray(res.list) && res.list.length > 0) {
          this.latestReport = res.list[0];
        } else if (res && typeof res === 'object' && !res.list) {
          // 单个对象直接使用
          this.latestReport = res;
        } else {
          //console.log('[北交所调研报告] 没有数据');
        }
      } catch (err) {
        console.error('获取北交所调研报告失败：', err);
      }
    },
    
    // 获取最新调研报告（新三板）
    async fetchLatestNQReport() {
      try {
        const res = await newThirdBoardApi.getReschReport({
          page_idx: 1,
          page_size: 1,  // 只获取第一条
          comp_exch: 'NQ'
        });
        
        //console.log('[新三板调研报告] 接口返回:', res);
        
        // 兼容处理：单条数据时返回对象，多条数据时返回 list 数组
        if (Array.isArray(res)) {
          this.latestNQReport = res[0];
        } else if (res && res.list && Array.isArray(res.list) && res.list.length > 0) {
          this.latestNQReport = res.list[0];
        } else if (res && typeof res === 'object' && !res.list) {
          // 单个对象直接使用
          this.latestNQReport = res;
        } else {
         // console.log('[新三板调研报告] 没有数据');
        }
      } catch (err) {
        console.error('获取新三板调研报告失败：', err);
      }
    },
    
    // 初始化迷你图表
    initMiniChart() {
      const ctx = document.getElementById('top50MiniChart');
      if (!ctx) {
        return;
      }
      
      // 先销毁旧图表，避免 Canvas 已被使用的错误
      if (this.chartInstance) {
        try {
          this.chartInstance.destroy();
        } catch (e) {
          console.error('[Top50卡片图表] 销毁旧图表失败:', e);
        }
        this.chartInstance = null;
      }
      
      // 额外检查：清理 Canvas 上可能残留的 Chart 实例
      const existingChart = Chart.getChart(ctx);
      if (existingChart) {
        existingChart.destroy();
      }
      
      const getDate = i => i.trade_date || i.date;
      const getVal = i => parseFloat(i.price_change) || parseFloat(i.index_value) || 0;
      
      const sortData = data => [...data]
        .filter(i => getDate(i) && !isNaN(new Date(getDate(i)).getTime()))
        .sort((a, b) => new Date(getDate(a)) - new Date(getDate(b)));
      
      const sortedBJ = sortData(this.bjTop50IndexData);
      const sortedSH = sortData(this.shTop50IndexData);
      const sortedCustom = sortData(this.customIndexData);
      

      const bjMap = new Map(sortedBJ.map(i => [getDate(i), getVal(i)]));
      const shMap = new Map(sortedSH.map(i => [getDate(i), getVal(i)]));
      const customMap = new Map(sortedCustom.map(i => [getDate(i), getVal(i)]));
      
      const allDates = Array.from(new Set([
        ...bjMap.keys(),
        ...shMap.keys(),
        ...customMap.keys()
      ]))
        .filter(date => !isNaN(new Date(date).getTime()))
        .sort((a, b) => new Date(a) - new Date(b));
      
      if (allDates.length === 0) return;
      
      const datasets = [
        {
          label: '京证50',
          data: allDates.map(d => bjMap.get(d) ?? null),
          borderColor: '#1f77b4',
          borderWidth: 1.5,
          pointRadius: 0,
          tension: 0.3,
          fill: false,
          spanGaps: true
        },
        {
          label: '上证50',
          data: allDates.map(d => shMap.get(d) ?? null),
          borderColor: '#ff7f0e',
          borderWidth: 1.5,
          pointRadius: 0,
          tension: 0.3,
          fill: false,
          spanGaps: true
        }
      ];
      
      // 如果有子沐指数数据，添加第三条线
      if (this.customIndexData.length > 0) {
        datasets.push({
          label: '子沐指数',
          data: allDates.map(d => customMap.get(d) ?? null),
          borderColor: '#2ca02c',
          borderWidth: 1.5,
          pointRadius: 0,
          tension: 0.3,
          fill: false,
          spanGaps: true
        });
      }
      
        this.chartInstance = markRaw(new Chart(ctx, {
        type: 'line',
        data: { labels: allDates, datasets },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          interaction: { mode: 'index', intersect: false },
          plugins: {
            legend: { 
              position: 'top', 
              labels: { boxWidth: 8, font: { size: 10 }, padding: 8 } 
            },
            tooltip: { enabled: true }
          },
          scales: {
            x: { display: false },
            y: { 
              grid: { color: '#f0f0f0' },
              ticks: { font: { size: 9 } }
            }
          },
          animation: { duration: 0 }
        }
      }));
    },
    
    // 跳转到 Top50 页面
    goToTop50() {
      this.$router.push({ 
        name: 'top50PortfolioDetail',
        query: {
          group_type: 50,
          comp_exch: 'BJ',
          index_type: 'ZM'  // 传递 index_type 以显示子沐指数
        }
      });
    },
    
    // 跳转到调研报告页面（北交所）
    goToInvestigationReport() {
      this.$router.push({ 
        name: 'investigationReport',
        params: { comp_exch: 'BJ' }
      });
    },
    
    // 跳转到调研报告页面（新三板）
    goToNQInvestigationReport() {
      this.$router.push({ 
        name: 'investigationReport',
        params: { comp_exch: 'NQ' }
      });
    },
    
    // 处理委托调研按钮
    handleEntrustResearch(compExch) {
     // console.log('[委托调研] 接收到的 compExch:', compExch);
      this.currentBusinessType = "委托调研";
      this.currentCompExch = compExch;
      //console.log('[委托调研] 设置后的 currentCompExch:', this.currentCompExch);
      
      // 使用 $nextTick 确保数据更新后再显示弹窗
      this.$nextTick(() => {
        this.showModal = true;
      });
    },
    
    // 弹窗确认提交事件
    async handleModalConfirm(submitData) {
      try {
       // console.log('确认提交的信息：', submitData);
        
        const { primaryMarketApi } = await import('@/api/index.js');
        await primaryMarketApi.addBusiness(submitData);
        alert('您的' + submitData.businessType + '申请已确认提交，我们将尽快安排联系并调研！');
        this.showModal = false;
      } catch (error) {
        console.error('提交接口异常：', error);
        this.$message.error('提交失败，请稍后重试');
      }
    },
    
    // 弹窗关闭事件
    handleModalClose() {
      this.showModal = false;
    },
    
    // 格式化日期
    formatDate(dateStr) {
      if (!dateStr) return '';
      return dateStr.split(' ')[0];
    },
    
    // 格式化日期（只显示年月日，为空显示“未知”）
    formatDateOnly(dateStr) {
      if (!dateStr) return '未知';
      // 如果是日期时间格式，只取日期部分
      return dateStr.split(' ')[0];
    },
    
    // 隐藏用户名（如果不是当前用户，显示 ***）
    maskUserName(userName) {
      if (!userName) return '未知';
      const userStore = useUserStore();
      const currentUserName = userStore.getUserName;
      // 如果是当前用户，显示真实名字；否则显示 ***
      return userName === currentUserName ? userName : '***';
    },
    
    // 封面图加载失败处理
    handleImgError(e) {
      e.target.style.display = 'none';
      const defaultCover = e.target.parentElement.querySelector('.default-cover');
      if (defaultCover) {
        defaultCover.style.display = 'flex';
      }
    },
    
    // 卡片点击跳转
    handleCardClick(item) {
      if (item.route) {
        this.$router.push(item.route);
      }
    },
    
    // 获取龙虎榜最近交易数据
    async fetchDragonTigerData() {
      try {
        const res = await beijingStockApi.getLastTrade({});
        
        if (res && res.list && res.list.length > 0) {
          this.dragonTigerData = res.list.slice(0, 10); // 只取前10条
          
          this.$nextTick(() => {
            this.initDragonTigerChart();
          });
        }
      } catch (err) {
        console.error('获取龙虎榜数据失败：', err);
      }
    },
    
    // 初始化龙虎榜柱状图
    initDragonTigerChart() {
      const ctx = document.getElementById('dragonTigerChart');
      if (!ctx) return;
      
      // 销毁旧图表
      if (this.dragonTigerChartInstance) {
        try {
          this.dragonTigerChartInstance.destroy();
        } catch (e) {
          console.error('[龙虎榜图表] 销毁旧图表失败:', e);
        }
        this.dragonTigerChartInstance = null;
      }
      
      // 检查残留实例
      const existingChart = Chart.getChart(ctx);
      if (existingChart) {
        existingChart.destroy();
      }
      
      // 准备数据
      const labels = this.dragonTigerData.map(item => item.comp_name || item.comp_code);
      const volumeData = this.dragonTigerData.map(item => (item.trade_volum || 0) / 10000); // 成交量（万股）
      const turnoverData = this.dragonTigerData.map(item => (item.trade_turnover || 0)); // 成交额（万元）
      
      // 创建图表
      const newChart = new Chart(ctx, {
        type: 'bar',
        data: {
          labels: labels,
          datasets: [
            {
              label: '成交量（万股）',
              data: volumeData,
              backgroundColor: 'rgba(75, 192, 192, 0.6)',
              borderColor: 'rgb(75, 192, 192)',
              borderWidth: 1,
              yAxisID: 'y'
            },
            {
              label: '成交额（万元）',
              data: turnoverData,
              backgroundColor: 'rgba(255, 159, 64, 0.6)',
              borderColor: 'rgb(255, 159, 64)',
              borderWidth: 1,
              yAxisID: 'y1'
            }
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: true,
              position: 'top',
              labels: {
                font: { size: 10 },
                boxWidth: 12
              }
            },
            tooltip: {
              callbacks: {
                label: function(context) {
                  const label = context.dataset.label || '';
                  const value = context.parsed.y;
                  if (label.includes('成交量')) {
                    return label + ': ' + value.toLocaleString() + ' 万股';
                  } else {
                    return label + ': ' + value.toLocaleString() + ' 万元';
                  }
                }
              }
            }
          },
          scales: {
            x: {
              ticks: {
                font: { size: 9 },
                maxRotation: 45,
                minRotation: 45
              }
            },
            y: {
              type: 'linear',
              position: 'left',
              beginAtZero: true,
              title: {
                display: true,
                text: '成交量（万股）',
                font: { size: 10 }
              },
              ticks: {
                font: { size: 10 },
                callback: function(value) {
                  return value.toLocaleString();
                }
              }
            },
            y1: {
              type: 'linear',
              position: 'right',
              beginAtZero: true,
              title: {
                display: true,
                text: '成交额（万元）',
                font: { size: 10 }
              },
              ticks: {
                font: { size: 10 },
                callback: function(value) {
                  return value.toLocaleString();
                }
              },
              grid: {
                drawOnChartArea: false
              }
            }
          }
        }
      });
      
      this.dragonTigerChartInstance = markRaw(newChart);
    },
    
    // 跳转到龙虎榜页面
    goToDragonTigerList() {
      this.$router.push({ name: 'dragonAndTigerList' });
    },
    // 获取IPO服务数据
    async fetchIpoServiceData() {
      try {
        const res = await ipoApi.getIpoService();
        
        if (res && res.list) {
          const dataList = res.list;
          
          // 遍历每个 IPO 卡片，根据 dataKey 匹配数据
          this.ipoList.forEach(card => {
            const dataItem = dataList.find(item => item.index_key === card.dataKey);
            if (dataItem) {
              card.count = dataItem.index_value || 0;
            }
          });
          
          this.ipoServiceData = dataList;
        }
      } catch (err) {
        console.error('[IPO服务] 请求失败:', err);
      }
    },
    // 获取北交所业务首页数据
    async fetchBeijingStockHomeData() {
      try {
        const res = await beijingStockApi.getBeijingStockHome();
        
        // 尝试两种数据结构
        let dataList = null;
        if (res && res.data && res.data.list) {
          dataList = res.data.list;
        } else if (res && res.list) {
          dataList = res.list;
        }
        
        if (dataList) {
          // 遍历每个北交所卡片，根据 dataKey 匹配数据
          this.beijingExchangeList.forEach(card => {
            const dataItem = dataList.find(item => item.index_key === card.dataKey);
            if (dataItem) {
              card.count = dataItem.index_value || 0;
            }
          });
          
          this.beijingStockHomeData = dataList;
        }
      } catch (err) {
        console.error('[北交所业务首页] 请求失败:', err);
      }
    },
    
    // 获取委托定增数据
    async fetchFixedIncreaseData() {
      try {
        const res = await primaryMarketApi.getBusiness({
          business_type: 1  // 1=委托定增
        });
        
        if (res) {
          // 兼容处理：可能是数组、单个对象或包含list的对象
          let dataList = [];
          if (Array.isArray(res)) {
            // 直接是数组
            dataList = res;
          } else if (res.list && Array.isArray(res.list)) {
            // 包含list字段的对象
            dataList = res.list;
          } else if (typeof res === 'object' && res.comp_name) {
            // 单个对象，转换为数组
            dataList = [res];
          }
          
          // 只取前5条
          this.fixedIncreaseList = dataList.slice(0, 5);
        }
      } catch (err) {
        console.error('[委托定增] 请求失败:', err);
      }
    },
    
    // 获取委托壳交易数据
    async fetchShellTransactionData() {
      try {
        const res = await primaryMarketApi.getBusiness({
          business_type: 2  // 2=委托卖/买壳
        });
        
        if (res) {
          // 兼容处理：可能是数组、单个对象或包含list的对象
          let dataList = [];
          if (Array.isArray(res)) {
            // 直接是数组
            dataList = res;
          } else if (res.list && Array.isArray(res.list)) {
            // 包含list字段的对象
            dataList = res.list;
          } else if (typeof res === 'object' && res.comp_name) {
            // 单个对象，转换为数组
            dataList = [res];
          }
          
          // 只取前5条
          this.shellTransactionList = dataList.slice(0, 5);
        }
      } catch (err) {
        console.error('[委托壳交易] 请求失败:', err);
      }
    },
    
    // 获取立项公司数据
    async fetchProjectFoundData() {
      try {
        const userStore = useUserStore();
        const res = await primaryMarketApi.getProjectDirectory({
          pstatus: 1,  // 1=立项
          creator_id: userStore.userId
        });
        
        if (res) {
          // 兼容处理：可能是数组、单个对象或包含list的对象
          let dataList = [];
          if (Array.isArray(res)) {
            // 直接是数组
            dataList = res;
          } else if (res.list && Array.isArray(res.list)) {
            // 包含list字段的对象
            dataList = res.list;
          } else if (typeof res === 'object' && res.comp_name) {
            // 单个对象，转换为数组
            dataList = [res];
          }
          
          // 只取前5条
          this.projectFoundList = dataList.slice(0, 5);
        }
      } catch (err) {
        console.error('[立项公司] 请求失败:', err);
      }
    },
    
    // 获取投前项目数据
    async fetchPreInvestmentData() {
      try {
        const userStore = useUserStore();
        const res = await primaryMarketApi.getProjectDirectory({
          pstatus: 10,  // 10=投前
          creator_id: userStore.userId
        });
        
        if (res) {
          // 兼容处理：可能是数组、单个对象或包含list的对象
          let dataList = [];
          if (Array.isArray(res)) {
            // 直接是数组
            dataList = res;
          } else if (res.list && Array.isArray(res.list)) {
            // 包含list字段的对象
            dataList = res.list;
          } else if (typeof res === 'object' && res.comp_name) {
            // 单个对象，转换为数组
            dataList = [res];
          }
          
          // 只取前5条
          this.preInvestmentList = dataList.slice(0, 5);
        }
      } catch (err) {
        console.error('[投前项目] 请求失败:', err);
      }
    },
    
    // 获取投中项目数据
    async fetchDuringInvestmentData() {
      try {
        const userStore = useUserStore();
        const res = await primaryMarketApi.getProjectDirectory({
          pstatus: 11,  // 11=投中
          creator_id: userStore.userId
        });
        
        if (res) {
          // 兼容处理：可能是数组、单个对象或包含list的对象
          let dataList = [];
          if (Array.isArray(res)) {
            // 直接是数组
            dataList = res;
          } else if (res.list && Array.isArray(res.list)) {
            // 包含list字段的对象
            dataList = res.list;
          } else if (typeof res === 'object' && res.comp_name) {
            // 单个对象，转换为数组
            dataList = [res];
          }
          
          // 只取前5条
          this.duringInvestmentList = dataList.slice(0, 5);
        }
      } catch (err) {
        console.error('[投中项目] 请求失败:', err);
      }
    },
    
    // 跳转到定向增发页面
    goToPrivatePlacement() {
      this.$router.push({ name: 'privatePlacement' });
    },
    
    // 跳转到壳交易页面
    goToShellTransactions() {
      this.$router.push({ name: 'shellTransactions' });
    },
    
    // 跳转到立项列表页面
    goToProjectFoundList() {
      this.$router.push({ name: 'projectFoundList' });
    },
    
    // 跳转到投前页面
    goToPreInvestment() {
      this.$router.push({ name: 'preInvestment' });
    },
    
    // 跳转到投中页面
    goToDuringInvestment() {
      this.$router.push({ name: 'duringInvestment' });
    },
    
    // 跳转到项目库页面（兼容旧方法）
    goToProjectDirectory() {
      this.$router.push({ name: 'projectDirectory' });
    }
  }
};
</script>

<style scoped>
.content {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 5px 2px;
  padding-bottom: 100px;
  box-sizing: border-box;
  background-color: #f8f9fa;
  overflow-y: auto;
  overflow-x: hidden;
  height: calc(100vh - 60px);
}

/* 自定义滚动条样式 */
.content::-webkit-scrollbar {
  width: 6px;
}

.content::-webkit-scrollbar-track {
  background: transparent;
}

.content::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
  transition: background-color 0.3s;
}

.content::-webkit-scrollbar-thumb:hover {
  background-color: rgba(0, 0, 0, 0.3);
}

/* 业务分类容器 */
.business-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

/* 分类标题 */
.business-category {
  width: 100%;
}

.category-title {
  margin: 0 0 15px 0;
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

/* 标签样式复用 */
.tag {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 4px;
  color: white;
  font-size: 14px;
  font-weight: 500;
}

.tag.beijing-exchange {
  background-color: #ff7f50;
}

.tag.ipo {
  background-color: #ff4500;
}

.tag.w-third-boardne {
  background-color: #ffd700;
  color: #333;
}

.tag.primary-market {
  background-color: #32cd32;
}

/* 卡片列表 */
.card-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 15px;
  width: 100%;
}

/* 北交所缩小卡片列表 */
.card-list-small {
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
}

/* 3列布局 */
.card-list-3 {
  grid-template-columns: repeat(3, 1fr);
  margin-top: 15px;
}

/* IPO 5列布局 */
.card-list-5 {
  grid-template-columns: repeat(5, 1fr);
}

/* 北交所卡片列表：3列布局 */
.bj-card-list {
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
}

/* IPO 卡片列表：3列布局 */
.ipo-card-list {
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
}

/* IPO 卡片样式：内部分三个区域 */
.ipo-card {
  display: grid;
  grid-template-columns: 2fr 2fr 0.8fr;
  gap: 8px;
  align-items: center;
  padding: 10px;
}

/* 左区：图标+标题+描述 */
.ipo-left {
  display: flex;
  align-items: center;
  gap: 8px;
}

.ipo-text {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.ipo-title {
  font-size: 14px;
  font-weight: 600;
  color: #333;
  white-space: nowrap;
}

.ipo-desc {
  font-size: 11px;
  color: #999;
  white-space: nowrap;
}

/* 中区：大数字 */
.ipo-center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.ipo-number {
  font-size: 32px;
  font-weight: 700;
  color: #ff8c5a;
  line-height: 1;
}

.ipo-loading {
  font-size: 24px;
  color: #ddd;
}

/* 右区：单位 */
.ipo-right {
  display: flex;
  align-items: center;
  justify-content: center;
}

.ipo-unit {
  font-size: 18px;
  color: #333;
  font-weight: 500;
}

/* 空占位符（用于没有数据的卡片） */
.ipo-placeholder {
  display: inline-block;
  width: 100%;
  height: 1px;
  visibility: hidden;
}

/* 一级市场 1列布局 */
.card-list-1 {
  grid-template-columns: repeat(1, 180px);
}

/* Top50 大卡片样式 */
.featured-cards {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  margin-bottom: 15px;
}

.featured-card {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  padding: 15px;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
  min-width: 0;  /* 确保所有卡片宽度一致 */
}

.featured-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.featured-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.featured-badge {
  display: inline-block;
  padding: 3px 8px;
  background: #f5f5f5;
  border-radius: 4px;
  font-size: 11px;
  color: #666;
}

.featured-main {
  margin-bottom: 12px;
}

.featured-value {
  font-size: 24px;
  font-weight: 700;
  line-height: 1.2;
}

.featured-value.value-up {
  color: #ff4500;
}

.featured-value.value-down {
  color: #32cd32;
}

.featured-label {
  font-size: 12px;
  color: #999;
  margin-top: 2px;
}

.featured-periods {
  display: flex;
  gap: 12px;
  padding: 8px 0;
  border-top: 1px solid #f0f0f0;
  border-bottom: 1px solid #f0f0f0;
  margin-bottom: 10px;
}

.period-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 36px;
}

.period-label {
  font-size: 11px;
  color: #999;
  margin-bottom: 2px;
}

.period-value {
  font-size: 12px;
  font-weight: 600;
}

.period-value.value-up {
  color: #ff4500;
}

.period-value.value-down {
  color: #32cd32;
}

.featured-chart {
  height: 100px;
  width: 100%;
}

/* 预留卡片样式 */
.featured-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f9f9f9;
  border: 1px dashed #ddd;
  cursor: default;
}

.placeholder-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
}

.placeholder-icon {
  font-size: 24px;
  color: #ccc;
}

.placeholder-text {
  font-size: 12px;
  color: #999;
}

/* 业务列表卡片样式 */
.featured-card-list {
  display: flex;
  flex-direction: column;
  padding: 15px;
  transition: all 0.3s;
}

.featured-card-list:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
}

.list-content {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 10px;
  max-height: 250px;  /* 限制最大高度，大约5行的高度 */
  overflow-y: auto;  /* 超出时显示滚动条 */
}

/* 自定义滚动条样式 */
.list-content::-webkit-scrollbar {
  width: 4px;
}

.list-content::-webkit-scrollbar-track {
  background: transparent;
}

.list-content::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 2px;
}

.list-content::-webkit-scrollbar-thumb:hover {
  background-color: rgba(0, 0, 0, 0.3);
}

.list-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 10px;
  background-color: #f8f9fa;
  border-radius: 4px;
  transition: background-color 0.3s;
}

.list-item:hover {
  background-color: #e9ecef;
}

.item-code {
  font-size: 13px;
  font-weight: 600;
  color: #666;
  min-width: 80px;
}

.item-name {
  flex: 1;
  font-size: 14px;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.item-tag {
  font-size: 12px;
  padding: 2px 8px;
  background-color: #e6f7ff;
  color: #1890ff;
  border-radius: 3px;
  white-space: nowrap;
}

.list-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 30px;
  color: #999;
  font-size: 13px;
}

/* 报告卡片暂无数据样式 */
.report-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 60px 30px;
  color: #999;
  font-size: 14px;
  flex: 1;
}

/* 调研报告卡片样式 */
.featured-card-report {
  padding: 0 !important;
  display: flex;
  flex-direction: column;
  overflow: visible !important;  /* 改为 visible */
  cursor: default !important;
}

/* 顶部操作栏 */
.report-top-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  background-color: #f8f9fa;
  border-bottom: 1px solid #e8e8e8;
  flex-shrink: 0;
}

/* 委托调查按钮 */
.entrust-btn {
  padding: 4px 12px;
  font-size: 13px;
  color: #333;
  background-color: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s;
}

.entrust-btn:hover {
  color: #1890ff;
  border-color: #1890ff;
}

/* More链接 */
.more-link {
  font-size: 13px;
  color: #666;
  cursor: pointer;
  transition: color 0.3s;
}

.more-link:hover {
  color: #1890ff;
}

/* 报告卡片主体 */
.report-card-body {
  display: flex;
  flex-direction: column;  /* 改为垂直排列：图片在上，内容在下 */
  cursor: pointer;
  overflow: visible !important;
  background-color: #ffffff !important;
}

.report-card-body:hover .card-content {
  background-color: #fafafa !important;
}

/* 强制所有文字元素可见 */
.report-card-body * {
  opacity: 1 !important;
  visibility: visible !important;
}

.card-cover {
  width: 100%;  /* 宽度充满 */
  height: 160px;  /* 增加高度，从160px加到200px */
  background-color: #f8f9fa;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  flex-shrink: 0;
  overflow: hidden;
}

.default-cover {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #1890ff;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.file-icon {
  font-size: 36px;
  color: #fff;
}

.cover-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.card-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 12px 15px;
  gap: 8px;
  background-color: #ffffff !important;
  overflow: visible;
  position: relative;
  z-index: 10;
}

/* 简化的报告信息布局 */
.report-info {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  position: relative;
  z-index: 10;
}

/* 标题和日期同一行 */
.title-date-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
}

/* 公司信息（名称+代码） */
.company-info {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
  position: relative;
  z-index: 10;
}

.company-name-large {
  font-size: 16px !important;
  font-weight: 700 !important;
  color: #333333 !important;  /* 强制颜色 */
  line-height: 1.3;
  opacity: 1 !important;  /* 强制不透明 */
  visibility: visible !important;  /* 强制可见 */
}

.company-code {
  font-size: 14px !important;
  color: #666666 !important;  /* 强制颜色 */
  font-weight: 500;
  opacity: 1 !important;
  visibility: visible !important;
}

/* 日期 */
.report-date {
  font-size: 13px !important;
  color: #999999 !important;
  line-height: 1.3;
  white-space: nowrap;
  flex-shrink: 0;
  opacity: 1 !important;
  visibility: visible !important;
}

/* 调研标题 */
.report-title-main {
  font-size: 15px !important;
  font-weight: 600 !important;
  color: #333333 !important;
  line-height: 1.5;
  margin: 0;
  flex: 1;
  min-width: 0;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  opacity: 1 !important;
  visibility: visible !important;
}

/* 报告类型标签 */
.report-tag-small {
  display: inline-block;
  font-size: 11px !important;
  color: #1890ff !important;  /* 强制颜色 */
  background-color: #e6f7ff !important;  /* 强制背景色 */
  padding: 3px 10px;
  border-radius: 12px;
  align-self: flex-start;
  opacity: 1 !important;
  visibility: visible !important;
}

.report-header-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 6px;
  position: relative;
  z-index: 2;
}

.report-meta-left {
  display: flex;
  flex-direction: column;
  gap: 3px;
  flex: 1;
  min-width: 0;
  position: relative;
  z-index: 2;
}

.company-name {
  font-size: 14px;  /* 加大字号 */
  color: #333 !important;  /* 强制颜色 */
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  position: relative;
  z-index: 3;
}

.meta-date {
  font-size: 12px;  /* 加大字号 */
  color: #999 !important;  /* 强制颜色 */
  position: relative;
  z-index: 3;
}

.report-tag {
  font-size: 11px;  /* 加大字号 */
  color: #1890ff !important;  /* 强制颜色 */
  background-color: #e6f7ff;
  padding: 2px 8px;
  border-radius: 10px;
  white-space: nowrap;
  flex-shrink: 0;
  margin-left: 8px;
  position: relative;
  z-index: 3;
}

.report-title-mini {
  font-size: 13px;
  font-weight: 600;
  color: #333;
  margin: 0 0 4px 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  line-height: 1.4;
  min-height: 36px;
}

/* 更大的标题样式 */
.report-title-large {
  font-size: 16px;
  font-weight: 700;
  color: #333 !important;  /* 强制颜色 */
  margin: 0 0 6px 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  line-height: 1.5;
  min-height: 48px;
  position: relative;
  z-index: 2;
}

.report-brief {
  font-size: 12px;  /* 加大字号 */
  color: #666 !important;  /* 强制颜色 */
  line-height: 1.5;
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  position: relative;
  z-index: 2;
}

/* 业务卡片样式 */
.business-card {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  padding: 15px;
  transition: transform 0.2s, box-shadow 0.2s;
  cursor: pointer;
}

.business-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

/* 北交所缩小卡片样式 */
.business-card-small {
  display: flex;
  align-items: center;
  padding: 12px;
  gap: 12px;
}

.card-icon {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 18px;
  flex-shrink: 0;
}

.card-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
  overflow: hidden;
  flex: 1;
}

.card-title-small {
  font-size: 14px;
  font-weight: 600;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.card-desc-small {
  font-size: 12px;
  color: #999;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 卡片数量显示 */
.card-count {
  display: flex;
  align-items: baseline;
  gap: 2px;
  line-height: 1;
}

.count-number {
  font-size: 26px;
  font-weight: 700;
  color: #ff4500;
}

.count-unit {
  font-size: 15px;
  color: #666;
  font-weight: 500;
}

/* 卡片内部样式 */
.card-header {
  margin-bottom: 10px;
  padding-bottom: 8px;
  border-bottom: 1px solid #f0f0f0;
}

.card-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.card-body {
  margin-bottom: 10px;
}

.card-desc {
  font-size: 14px;
  color: #666;
  line-height: 1.5;
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.card-footer {
  padding-top: 8px;
  border-top: 1px solid #f0f0f0;
}

.card-tag {
  font-size: 12px;
  color: #999;
}
.card-cover {
  width: 100%;
  height: 160px;
  background-color: #f8f9fa;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  flex-shrink: 0;
}

/* 龙虎榜柱状图卡片样式 */
.featured-card-chart {
  display: flex;
  flex-direction: column;
  cursor: pointer;
  transition: all 0.3s ease;
}

.featured-card-chart:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
}

.featured-chart-full {
  flex: 1;
  padding: 10px;
  min-height: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.featured-chart-full canvas {
  max-height: 200px;
  width: 100% !important;
}

/* 响应式适配 */
@media (max-width: 1200px) {
  .featured-cards {
    grid-template-columns: repeat(2, 1fr);
  }
  .card-list-small {
    grid-template-columns: repeat(2, 1fr);
  }
  .card-list-3 {
    grid-template-columns: repeat(3, 1fr);
  }
  .card-list-5 {
    grid-template-columns: repeat(3, 1fr);
  }
  .featured-value {
    font-size: 20px;
  }
}

@media (max-width: 768px) {
  .featured-cards {
    grid-template-columns: 1fr;
  }
  .card-list {
    grid-template-columns: repeat(auto-fill, minmax(100%, 1fr));
  }
  .card-list-small,
  .card-list-3,
  .card-list-5 {
    grid-template-columns: 1fr;
  }
  .card-list-1 {
    grid-template-columns: 1fr;
  }
  .featured-value {
    font-size: 18px;
  }
  .featured-periods {
    flex-wrap: wrap;
    gap: 8px;
  }
  .featured-chart {
    height: 70px;
  }
}
</style>